import { ANIMAL_GENDERS, ANIMAL_STATUS_ENUM } from "@/features/farm"
import { useAppSelector } from "@/redux/hooks.ts"

const useGetAnimalsOptionsWithCount = () => {
  const animalFilterOptionsWithCount = useAppSelector(
    (state) => state.animalFilterSlice,
  )

  const animalStatusesWithCount = Object.entries(ANIMAL_STATUS_ENUM).map(
    ([key, value]) => ({
      label: key,
      value: value,
      count: animalFilterOptionsWithCount.statuses[value],
    }),
  )

  const animalGendersWithCount = Object.values(ANIMAL_GENDERS).map(
    ({ label }) => ({
      label: label,
      value: label,
      count: animalFilterOptionsWithCount.genders[label],
    }),
  )

  return {
    animalStatusesWithCount,
    animalGendersWithCount,
  }
}

export default useGetAnimalsOptionsWithCount
